import Konva from 'konva';
import React from 'react';
import { roundMinute } from 'utils/time';
import { DateRange } from "types/global"
import { GraphGroup, GraphStyle } from '../types';
import { calcGroupTots } from '../utils';
import Tooltip from './Tooltip';


function TooltipSum({
	dateRange,
	group,
	style,
	...props
}:TooltipSumProps) {
	if (group.name != "task" && group.name != "yield") return null
	if (!group || dateRange.end==null || dateRange.start==null || dateRange.end== dateRange.start) return null

	const labels = calcGroupTots(group, dateRange)
		.map(value => group.name == "task" ? roundMinute(value) : `${value}kg` ) 
	
	const title =  group.name == "yield" ? "Totals" : null

	return <Tooltip
		title={title}
		labels={labels}
		style={style}
		{...props}
	/>
}

export default TooltipSum

type TooltipSumProps = {
	dateRange: DateRange,
	group: GraphGroup,
	style: GraphStyle,
} & Konva.NodeConfig
